const Flux = require('flux');

const dispatcher = new Flux.Dispatcher();
// dispatcher.register((action) => {
//     console.log(action);
// });

module.exports = dispatcher;



// WEBPACK FOOTER //
// ./common/domain/repository/dispatcher.js